module.exports = __webpack_public_path__ + "img/new3.db631d5e.png";